import * as actionTypes from '../actions/actionTypes';

const initialState = {
    ticket_list: [],
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.TICKETS_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                ticket_list: []
            };
        case actionTypes.TICKETS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                ticket_list: []
            };
        case actionTypes.TICKETS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                ticket_list: action.payload.data
            };
        default:
            return state;
    }
};

export default reducer;